import "./RestaurantMenus.css";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";  // ← added
import { getCategories } from "../api/CategoryApi";
import { getMenuItems } from "../api/MenuItemApi";
import { getRestaurantByIdAsync } from "../api/RestaurantApi";
import { getAuthData } from "../utils/CommonMethods";

import { CategoryDto } from "../api/CategoryApi";
import { MenuItem } from "../api/MenuItemApi";
import { RestaurantResponse } from "../models/RestaurantResponse";

interface Props {
  /** Optional prop – used when the component is rendered directly with an ID */
  restaurantId?: string;
}

const RestaurantMenuPage: React.FC<Props> = ({ restaurantId: propRestaurantId }) => {
  const { id: paramId } = useParams<{ id: string }>(); // ← read id from URL
  const restaurantId = propRestaurantId ?? paramId;   // ← prefer prop, fallback to URL param

  const [categories, setCategories] = useState<CategoryDto[]>([]);
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [restaurant, setRestaurant] = useState<RestaurantResponse | null>(null);

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (restaurantId) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [catRes, itemRes, resRes] = await Promise.all([
        getCategories(restaurantId!),
        getMenuItems(restaurantId!),
        getRestaurantByIdAsync(restaurantId!),
      ]);

      setCategories(Array.isArray(catRes.result) ? catRes.result : []);
      setMenuItems(Array.isArray(itemRes.result) ? itemRes.result : []);
      setRestaurant(resRes.result || null);

      if (catRes.result?.length > 0) {
        setSelectedCategory(catRes.result[0].id);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filteredItems = Array.isArray(menuItems)? selectedCategory? menuItems.filter((m) => m.categoryId === selectedCategory): menuItems: [];

  if (loading) return <div className="menu-loading">Loading menu...</div>;

  return (
    <div className="menu-page">
      {/* 🔥 RESTAURANT HEADER */}
      {restaurant && (
        <div className="restaurant-header">
          <img
            className="restaurant-image"
            src={
              restaurant.bannerUrl
                ? `http://localhost:5000${restaurant.bannerUrl}`
                : "/placeholder.png"
            }
            alt={restaurant.name}
          />
          <div className="restaurant-info">
            <h2>{restaurant.name}</h2>
            <p>{restaurant.description}</p>
            <p>
              📍 {restaurant.area}, {restaurant.city}
            </p>
          </div>
        </div>
      )}

      {/* 🔥 CATEGORY BAR */}
      <div className="category-bar">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`category-chip ${selectedCategory === cat.id ? "active" : ""}`}
            onClick={() => setSelectedCategory(cat.id)}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* 🔥 MENU LIST */}
      <div className="menu-list">
        {Array.isArray(filteredItems) &&
          filteredItems.map((item) => (
          <div key={item.id} className="menu-card">
            <div className="menu-info">
              <h4>{item.name}</h4>
              <p>{item.description}</p>

              <div className="menu-meta">
                <span className="price">৳ {item.price}</span>
                {!item.isAvailable && <span className="out">Not Available</span>}
              </div>
            </div>
            <div className="menu-image">
              <img
                src={item.imageUrl ? `http://localhost:5000${item.imageUrl}` : "/placeholder.png"}
                alt={item.name}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RestaurantMenuPage;